class OneParkService {
  constructor(client) {
    this.apiClient = client;
  }

  async getAdminSettings(facilityID) {
    return await this.apiClient.get(`onepark/${facilityID}/admin/settings`);
  }

  async saveAdminSettings(facilityID, settings) {
    return await this.apiClient.put(
      `onepark/${facilityID}/admin/settings`,
      settings
    );
  }
}

export default OneParkService;
